module.exports = __webpack_public_path__ + "static/media/quiz-hint-1-es.d363f9ba.vtt";